import { Component, OnInit, Inject } from '@angular/core';

import { UntypedFormControl } from '@angular/forms';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { SessionService } from '@tech-services/session.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogDataInterface } from '../modal-custom-date-report/dialog-data.interface';
import { TranslateService } from '@ngx-translate/core';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
@Component({
  selector: 'tech-modal-custom-date-trades',
  templateUrl: './modal-custom-date-trades.component.html',
  styleUrls: ['./modal-custom-date-trades.component.scss'],
})
export class ModalCustomDateTradesComponent implements OnInit {
  initialDateForm = new UntypedFormControl(new Date(this.data.initialDate));
  endDateForm = new UntypedFormControl(new Date(this.data.endDate));
  minDate: Date;
  maxDate: Date;
  initialDate: Date;
  endDate: Date;
  disableConfirm: boolean = false;
  faInfoCircle = faInfoCircle;

  constructor(
    public dialogRef: MatDialogRef<ModalCustomDateTradesComponent>,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataInterface,
    private translate: TranslateService
  ) {
    this.initialDate = new Date(this.data.initialDate);
    this.endDate = new Date(this.data.endDate);
    this.minDate = new Date(this.data.minDate);
    this.maxDate = new Date(this.data.maxDate);
    this._adapter.setLocale(localStorage.getItem('Language'));
  }

  ngOnInit() {}

  addDate(type: string, event: MatDatepickerInputEvent<Date>) {
    this.disableConfirm = event.value ? false : true;
    switch (type) {
      case 'initialDate':
        this.initialDate = event.value;
        break;
      case 'endDate':
        if (event.value && event.value <= this.maxDate) {
          this.endDate = event.value;
          this.disableConfirm = false;
        } else {
          this.disableConfirm = true;
        }
        break;
      default:
        break;
    }

    this.disableConfirm =
      this.initialDateForm.value && this.endDateForm.value ? false : true;
  }

  reset() {
    this.initialDate = this.minDate;
    this.endDate = this.maxDate;
    this.dialogRef.close({
      initialDate: this.initialDate,
      endDate: this.endDate,
    });
  }
}
